// The server answers a rejected save with `{ error, messages: [...] }`, and the Axios
// interceptor rejects with that body. Those messages are written for the owner (they name
// the day and say what to change), so they are shown as sent.
//
// Anything else is a network failure, or a proxy's HTML error page, which the interceptor
// passes through as a string. Neither is worth showing verbatim, so it gets the fallback.
export default function saveErrorMessage(error, fallback = 'We could not save your settings. Please try again.') {
  if (Array.isArray(error?.messages) && error.messages.length > 0) {
    return error.messages.join('\n');
  }
  return fallback;
}
